module.exports = __webpack_public_path__ + "dist/media/lorenzo-quinn.bc43f9e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/team/lorenzo-quinn.png
// module id = 383
// module chunks = 0